export const ModalSolicitudes = ({children, isOpen, closeModal}) => {

  const handleModalContainerClick = e => e.stopPropagation()
  
  return (
    <article className={`modal-solicitudes ${isOpen && "is-open"}`} onClick={closeModal}>
      <div className="modal-container-solicitudes" onClick={handleModalContainerClick}>
      <button className="modal-close-solicitudes cancelButton" onClick={closeModal}>X</button>
        {children}
      </div>
    </article>
  )
}